<template>
  <div id="tasks_analytics_grid">
    <InfoGrid :columns="3">
      <ContainerInfoItem
        v-for="(data, key) in analyticsData"
        :key="key"
        source="linkedin_tasks_activity_analytics"
        :title="data.title"
        :description="range?.label || ''"
        :value="formatAnalyticsValue(data.value, data.unit)"
        :is-loading="data.isLoading"
      />
    </InfoGrid>
  </div>
</template>

<script setup>
import {computed, reactive, watch, watchEffect} from "vue";
import { formatAnalyticsValue } from "@/src/utils/analyticUtils.js";
import { sequenceTaskActions } from "@/src/constants/analyticConstants.js";
import store from "@/src/store/index.js";
import AnalyticService from "@/src/api/AnalyticService.js";
import InfoGrid from "@/src/components/info_components/InfoGrid.vue";
import ContainerInfoItem from "@/src/components/info_components/ContainerInfoItem.vue";
import { useAnalyticsRefresh } from "@/src/composables/useAnalyticsRefresh.js";

const range = computed(() => store.getters["analytics/getRange"]);
const filters = computed(() => store.getters["analytics/getFilters"]);
const userIds = computed(() => store.getters["analytics/getUserIds"]);
const teamIds = computed(() => store.getters["analytics/getTeamIds"]);

const analyticsData = reactive([
  {
    id: sequenceTaskActions.TASK_CREATED,
    title: "Total tasks",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceTaskActions.TASK_COMPLETED,
    title: "Tasks done",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceTaskActions.TASK_PENDING,
    title: "Tasks pending",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceTaskActions.TASK_OVERDUE,
    title: "Tasks overdue",
    value: 0,
    isLoading: false,
  },
]);

const fetchAnalytics = async () => {
  analyticsData.forEach((item) => {
    item.isLoading = true;
  });

  try {
    const params = {
      user_id: userIds.value,
      team_id: teamIds.value,
      start_time: range.value?.start,
      end_time: range.value?.end,
      sequence_id: filters.value?.sequence?.id,
    }
    AnalyticService.V2.fetchSequenceTasksCount(params).then((response) => {
      if (response?.success) {
        const data = response?.data?.results;
        analyticsData.forEach((item) => {
          item.value = data[item.id] || 0;
        });
      }
    }).catch((error) => {
      console.error("An error occurred while fetching analytics: ", error);
    });
  } catch (error) {
    console.error("An error occurred while fetching analytics: ", error);
  } finally {
    analyticsData.forEach((item) => {
      item.isLoading = false;
    });
  }
};


watch([range, filters, userIds, teamIds], () => {
  if (range.value || filters.value?.sequence?.id) fetchAnalytics();
}, { deep: true });

// Enable 60s auto-refresh
useAnalyticsRefresh(fetchAnalytics, [range, userIds, teamIds]);
</script>
